import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { listAdminAssessments, type AdminAssessment } from '../../services/assessmentsApi'

export default function AssessmentList() {
  const [assessments, setAssessments] = useState<AdminAssessment[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    listAdminAssessments()
      .then(setAssessments)
      .catch(() => setError('Failed to load assessments.'))
      .finally(() => setLoading(false))
  }, [])

  const origin = window.location.origin

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-bold">Assessments</h2>
          <p className="text-gray-400 text-sm">Create shareable proctored assessment links</p>
        </div>
        <Link
          to="/admin/assessments/new"
          className="bg-primary-500 hover:bg-primary-600 px-4 py-2 rounded-lg text-sm font-medium"
        >
          New assessment
        </Link>
      </div>

      {loading && <p className="text-gray-400">Loading...</p>}
      {error && <p className="text-red-400">{error}</p>}

      {!loading && assessments.length === 0 && (
        <div className="glass-card p-6 text-gray-400">No assessments yet. Create your first one.</div>
      )}

      <div className="space-y-3">
        {assessments.map((item) => (
          <div key={item.slug} className="glass-card p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
            <div>
              <div className="flex items-center gap-2">
                <h3 className="font-semibold text-white">{item.title}</h3>
                <StatusBadge status={item.status} />
              </div>
              <p className="text-sm text-gray-400 mt-1">
                <code className="text-primary-300">{origin}/{item.slug}</code>
              </p>
            </div>
            <Link
              to={`/admin/assessments/${item.slug}/edit`}
              className="text-sm px-3 py-1.5 rounded border border-assess-border hover:bg-assess-card self-start"
            >
              Edit
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

function StatusBadge({ status }: { status: string }) {
  const colors: Record<string, string> = {
    published: 'bg-green-500/20 text-green-400',
    draft: 'bg-yellow-500/20 text-yellow-400',
    archived: 'bg-gray-500/20 text-gray-400',
  }
  return (
    <span className={`text-xs px-2 py-0.5 rounded ${colors[status] ?? colors.draft}`}>
      {status}
    </span>
  )
}
